import { Injectable } from '@angular/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import {
  esLocale, enGbLocale, ukLocale, plLocale,
  frLocale, itLocale, deLocale, ptBrLocale,
  trLocale, viLocale, ruLocale
} from 'ngx-bootstrap/locale';

@Injectable({ providedIn: 'root' })
export class LanguageInitService {
  init() {
    defineLocale('en-gb', enGbLocale);
    defineLocale('uk', ukLocale);
    defineLocale('es', esLocale);
    defineLocale('es-419', esLocale);
    defineLocale('pl', plLocale);
    defineLocale('fr', frLocale);
    defineLocale('it', itLocale);
    defineLocale('de', deLocale);
    defineLocale('pt', ptBrLocale);
    defineLocale('tr', trLocale);
    defineLocale('vi', viLocale);
    defineLocale('ru', ruLocale);
  }
}